import React from 'react';
import Navbar from './global-components/navbar';
import PageHeader from './global-components/page-header';
import ContactInfo from './section-components/contact-info';
import ContactForm from './section-components/contact-form';
import Map from './section-components/map';
import CallToActionV1 from './section-components/call-to-action-v1';
import Footer from './global-components/footer';
import {Link} from "react-router-dom";
import Comments from "./blog-components/comments";
import { Helmet } from 'react-helmet';

/**
 * @typedef Project
 * @property {string} name
 * @property {string} location
 * @property {string[]} imageFilenames
 * @property {string} description
 * @property {string} agentDetails
 * @property {string} enquire
 */

const ProjectCurrent = () => {
  let publicUrl = process.env.PUBLIC_URL + '/'

  const projects = [
    {
      name: 'CAMBER-WELL',
      location: '1269 Toorak Road Camberwell VIC 3124',
      description: 'This architecturally designed modern 6 townhouses offer the ultimate in eco-friendly and contemporary living with privacy and security of a gated estate, and features high-end fixtures and cutting-edge design throughout, embracing the European lifestyle of Camberwell \n' +
        '\n' +
        'Radiant living set across the ground floor offers the feel of a home with the freedom of a low-maintenance lot on its own title. It\'s an effortless setting that frees you to indulge in life\'s finer things. Take advantage of esteemed private schools and universities, just metres from Hartwell Primary School and zoned for Camberwell High School, the tram is at your doorstep for a swift trip to Deakin University, Presbyterian Ladies\' College, Camberwell/Kew private schools and Camberwell Junction. An easy walk to the city-bound train, and stroll down the street to enjoy buzzing cafes at Burwood Village and Hartwell Village.\n',
      agentDetails: 'NOW SELLING\n' +
        'INSPECTION BY APPOINTMENT\n' +
        'Chloe Zang 0430 034 988\n' +
        'Gavin Liu 0406 679 777\n',
      enquire: 'To enquire about this property marketed by Hoyee Projects Team, call 0422 877 500 or email info@hoyee.com.au\n',
      imageFilenames: [
        'assets/img/projects/camber_well_1.jpg',
        'assets/img/projects/camber_well_2.jpg',
        'assets/img/projects/camber_well_3.jpg',
        'assets/img/projects/camber_well_4.jpg',
        'assets/img/projects/camber_well_5.jpg',
        'assets/img/projects/camber_well_6.jpg',
        'assets/img/projects/camber_well_7.jpg',
      ],
    },
    {
      name: 'The Jersey',
      location: '29 Jersey Parade Carnegie VIC 3163',
      description: 'A complex of 10 magnificent residences that embody the epitome of contemporary living, offering a luxurious, low-maintenance lifestyle right at your fingertips. Nestled in the prestigious "The Jersey" boutique development, this architecturally designed gem is the perfect sanctuary for young couples, families, professionals on the go, or astute investors. Close to the new elevated Carnegie Railway Station.',
      agentDetails: 'NOW SELLING\n' +
        'INSPECTION BY APPOINTMENT\n' +
        'Chloe Zang 0430 034 988\n' +
        'Gavin Liu 0406 679 777\n',
      enquire: 'To enquire about this property marketed by Hoyee Projects Team, call 0422 877 500 or email info@hoyee.com.au',
      imageFilenames: [
        'assets/img/projects/the_jersey_1.jpg',
        'assets/img/projects/the_jersey_2.jpg',
        'assets/img/projects/the_jersey_3.jpg',
        'assets/img/projects/the_jersey_4.jpg',
        'assets/img/projects/the_jersey_5.jpg',
        'assets/img/projects/the_jersey_6.jpg',
        'assets/img/projects/the_jersey_7.jpg',
      ],
    },
  ]

  /**
   * @param project {Project}
   * @returns {JSX.Element}
   */
  const projectCard = (project) => {
    return (
    <div className="col-lg-6 col-sm-6 col-12">
      <Helmet>
        <title>Hoyee Property Group | Current Projects | Australia</title>
      </Helmet>

      <div className="ltn__blog-item ltn__blog-item-3">
          <div className="ltn__blog-img" style={{ position: 'relative' }}>
            <Link to={`/project-details?name=${project.name}`}>
              <img src={publicUrl + `${project.imageFilenames[0]}`} alt="#"/>
              <h3 style={{
                position: 'absolute',
                margin: '10%',
                top: '0',
                left: '0',
                right: '0',
                bottom: '0',
                color: '#fff',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: '700',
                fontSize: '1.5em',
                fontFamily: 'sans-serif',
                textAlign: 'center',
              }}>
                {project.name.toUpperCase()},<br/>
                {project.location.toUpperCase()}
              </h3>
            </Link>
          </div>
        </div>
      </div>
    )
  }

  return <div>
    <Navbar/>
    <PageHeader headertitle="" subheader="Current Projects"/>
    <>
      <div className="ltn__blog-details-wrap">
        <div className="ltn__page-details-inner">
          <h1 className="ltn__blog-title" style={{textAlign: "center"}}>Current Projects</h1>
          <div className="ltn__blog-area ltn__blog-item-3-normal mb-100 go-top">
            <div className="container">
              <div className="row">
                {projects.map((project, index) => projectCard(project, index))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
    <ContactForm/>

    <ContactInfo/>
    {/*<Map />*/}
    {/*<CallToActionV1 />*/}
    <Footer/>
  </div>
}

export default ProjectCurrent
